/**************************************************
 * Nombre:       Dialogo_Funnel_Videos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {usePestanasFormularios} from "../../../Modulo_CRM/Hooks/usePestanasFormularios";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Estado from "../../Formularios/Funnels/Formulario_Estado";
import {Delete} from "@mui/icons-material";
import {subirImagenHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../../Recursos/logo_redondo.svg";
import Formulario_Video_Uno from "../../Formularios/Funnels/Formulario_Video_Uno";
import {subirImgArrObjetos} from "../../../Servicios/AlmacenamientoHosting/subirImgArrObjetos";
import Formulario_Video_Dos from "../../Formularios/Funnels/Formulario_Video_Dos";
import Formulario_Video_Tres from "../../Formularios/Funnels/Formulario_Video_Tres";
import {subirVideoHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirVideoHostingFile";

const Dialogo_Funnel_Videos = ({datos, realizado, cerrar}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Pestanas} = usePestanasFormularios(
        {
            pestanas: ['Video Uno', 'Video Dos', 'Video Tres'],
            Formularios: [
                <Formulario_Video_Uno props={props}/>,
                <Formulario_Video_Dos props={props}/>,
                <Formulario_Video_Tres props={props}/>
            ]
        }
    )
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })

    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')

        let videoUno = await subirVideoHostingFile(entidad.videoUno)
        entidad.videoUno = videoUno.data

        let videoDos = await subirVideoHostingFile(entidad.videoDos)
        entidad.videoDos = videoDos.data

        let videoTres = await subirVideoHostingFile(entidad.videoTres)
        entidad.videoTres = videoTres.data





        nuevoAviso({aviso: 'Imagen subida'})


        let dox = await guardarDoc('funnels', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('funnels', datos.id)
        terminar({aviso: 'Funnel borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Pestanas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Funnel_Videos